var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-right":"20px"}},[_c('button',{staticClass:"btn btn-default btn-sm",staticStyle:{"height":"40px"},on:{"click":function($event){return _vm.send()}}},[_vm._v("Skicka SMS med länk till Google recensioner")])])
}
var staticRenderFns = []

export { render, staticRenderFns }